<template>
    <div class="">
        <button
            ref="button"
            type="button"
            @click="isOpen = true"
            class="p-2 flex items-center rounded-lg hover:bg-gray-100"
        >
            <ion-icon name="ellipsis-vertical"></ion-icon>
        </button>
        <Teleport to="body">
            <div
                v-if="isOpen"
                class="
                    fixed
                    top-0
                    left-0
                    z-10
                    bg-white bg-opacity-10
                    w-full
                    h-full
                "
                @click.self="isOpen = false"
            ></div>
            <div
                v-show="isOpen"
                ref="menu"
                class="
                    absolute
                    right-8
                    -top-8
                    bg-white
                    shadow-xl
                    rounded-lg
                    border border-gray-200
                    p-2
                    z-[1000]
                    w-auto
                    min-w-[200px]
                "
            >
                <ul @click="isOpen = false">
                    <slot></slot>
                </ul>
            </div>
        </Teleport>
    </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
    name: "NewContextMenu",
    data() {
        return {
            isOpen: false,
        };
    },
    updated() {
        if (this.isOpen) {
            this.$nextTick(() => {
                createPopper(this.$refs.button, this.$refs.menu, {
                    placement: "bottom-end",
                    boundariesElement: "viewport",
                }).forceUpdate();
            });
        }
    },
};
</script>

<style scoped></style>
